import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PopUp from '../../../../../Shared/Popup/PopUp';
import PopUpInfo from '../../PopUpInfo/PopUpInfo';
import { goToPage, setInfoPopUP } from '../../../PersonalAreaInvoicesSlice';
import arrowlarge from '../../../icons/arrow-large.svg';
import questionMark from '../../../icons/question-mark.svg';


 function QuestionsAnswers(props) {
  const [isShowPopUp,setIsShowPopUp] = useState(false);

  const handlerOnClick = (data, title)=>{
    const popupTitle = title ?? 'הודעות ועדכונים אישיים';
    setIsShowPopUp(true);
    props.setInfoPopUP({ data, title: popupTitle });
  };

  return (
    <div className='wrapper-questions-answers'>
      <button className='button-update' onClick={()=>handlerOnClick( props.invoicesInfo?.dalInfoForYo?.messages, props.invoicesInfo?.dalInfoForYo?.header)}> הודעות ועדכונים אישיים</button>
      <div className='wrapper-button'>
        <Image src={questionMark} alt='icon' className='img-button' />
        <button onClick={()=>props.goToPage('questionsAndAnswersPage')} className='section-questions-answers-page'>
          <div>שאלות לגבי החיוב</div>
          <div className='arrow-container'><Image src={arrowlarge} alt='icon' className='arrow' /></div>
        </button>
      </div>
      <PopUp showPopUp={isShowPopUp} onClose={() => setIsShowPopUp(false)}>
        <PopUpInfo></PopUpInfo>
      </PopUp>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo,
  };
};

const mapDispatchToProps = {
  goToPage,
  setInfoPopUP
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsAnswers);
